import React from "react";
import {connect} from "react-redux";
import {Dimensions, Image, StyleSheet, Text, TextInput, TouchableOpacity, View} from "react-native";
import BoutonText from "../Bouton/BoutonText";
import BoutonGenerale from "../Bouton/BoutonGenerale";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import AvatarIcon from "../Header/AvatarIcon";
import CameraPicto from "../Picto/CameraPicto";
import * as ImagePicker from "expo-image-picker";
import {editMyProfil} from "../../API/API";
import {wrapAction, wrapStyle} from "../../sw/helpers";
import resizeImage from "../Shared/image_resize_helper";
import {ActivityIndicator} from "react-native";


const profile_img_max_width = 150,
      profile_img_max_height = 150;

class EditProfilScreen extends React.Component{

    constructor(props) {
        super(props);
        this.setHeader();
        this.state ={
            nom:this.props.auth.compte.lastname,
            prenom:this.props.auth.compte.firstname,
            bio:this.props.auth.compte.biography,
            img:this.props.auth.compte.img,
            error: false,
            in_flight: false
        }
        this.setStateValue  = this.setStateValue.bind(this);
        this.pickImage  = this.pickImage.bind(this);
        this._confirmUpdate = this._confirmUpdate.bind(this);
    }

   async pickImage(){
        let result = await ImagePicker.launchImageLibraryAsync({
            mediaTypes: ImagePicker.MediaTypeOptions.All,
            allowsEditing: true,
            aspect: [4, 3],
            quality: 1,
        });

        if (result.cancelled) return

        this.setState({ in_flight: true });
        resizeImage(result.uri, profile_img_max_width, profile_img_max_height, (uri) => {
          this.setState({ in_flight: false, img: uri })
        })
    }

    _confirmUpdate(){
        let compte = {...this.props.auth.compte};
        const {nom, prenom, bio, img} = this.state;

        compte.lastname = nom;
        compte.firstname = prenom;
        compte.biography = bio;

        if (img.includes(";")) {
            // get rid of header of data uri scheme (data:image/jpeg;base64,/9j/4AAQSk...)
            compte.img = img.slice(img.indexOf(',') + 1);
        } else {
            // dont reupload the same image!
            delete compte.img;
        }

        this.setState({ in_flight: true, error: false });

        editMyProfil(compte).then(data=>{
           const action = {'type': 'SIGN_IN', 'value': compte};
            this.props.dispatch(action);
            this.props.navigation.goBack();
        }, () => {
          this.setState({ in_flight: false, error: this.props.t("An error occured") });
        });
    }
    getDimensions() {
        return Dimensions.get('window');
    }

    _displayInFlight(){
      if (this.state.in_flight) {
        const style = {
          position: 'absolute', left: 0, right: 0, top: 0, bottom: 0,
          alignItems: 'center', justifyContent: 'center',
          backgroundColor: "black", opacity: 0.6, zIndex: 100
        };
        return (
          <View style={style}>
            <View style={{position: "absolute", left: 0, right: 0, top: "20vh"}}>
              <ActivityIndicator size='large' color="#fff" />
            </View>
          </View>
        );
      }
    }

    setHeader(){
        this.props.navigation.setOptions({
            headerTitle : this.props.t('éditer mon profil'),
            headerStyle :{ backgroundColor : this.props.theme.colors.tertiary.grey3.value},
            headerTitleAlign: "center",
            headerLeft : ()=>
                <View style={{marginLeft:20}}  >
                    <BoutonText onPress={this.props.navigation.goBack} style={{textParent :{color : this.props.theme.colors.primary.blue1.value} }} bold={false} isRed={false} title={this.props.t("Annuler")} />
                </View>,
            headerRight : ()=>
                <View style={wrapStyle({})}>
                    <BoutonGenerale onPress={wrapAction(this._confirmUpdate)} title={this.props.t("Valider")} isActivate={true} size={"medium"} hasBorder={false}/>
                </View>
        });
    }

    setStateValue(text,obj){
        this.setState({
            [obj]:text
        });
    }


    render() {
        const { width, height } = this.getDimensions();
  
        const styles = StyleSheet.create({
            topContainer: wrapStyle({
                marginTop:25,
                marginBottom:30
            }),
            containerCamera:{
                position:"absolute",
                padding:7,
                backgroundColor:this.props.theme.colors.tertiary.grey3.value,
                borderRadius:35,
                top: 35,
                left: 50,
            },
            bottomContainer: {
            },
            inputContainer:{
                paddingVertical:20,
                paddingLeft:20,
                borderColor:this.props.theme.colors.tertiary.black13.value,
                borderTopWidth:1,
                borderBottomWidth:1,
               // alignItems:"center",
                flexDirection:"row",
            },
            labelInput:{
                fontFamily : this.props.theme.fonts.text,
                fontSize:15,
                fontWeight:"500",
                color:this.props.theme.colors.tertiary.black3.value,
                width:"40%"
            },
            textInput:{
                color : this.props.theme.colors.primary.blue1.value,
                marginRight:20,
                width:"40%"
            },
            error: {
              color: this.props.theme.colors.primary.error.value,
              padding: "10px",
              textAlign: "center",
              borderBottomWidth: 1,
              borderColor: "#ccc",
              fontFamily : this.props.theme.fonts.text,
              fontWeight: "500"
            }
        });

        const editable = this.props.online, selectTextOnFocus = this.props.online;

        return (
        <View style={{height:height,backgroundColor:this.props.theme.colors.primary.White.value}}>
            {this._displayInFlight()}
            { this.state.error && <View style={styles.error}>{ this.state.error }</View>}
            <View style={styles.topContainer}>
                <TouchableOpacity onPress={wrapAction(this.pickImage)} style={{flexDirection:"row"}}>
                    <AvatarIcon style={{width:60,height:60,borderWidth:0,borderRadius:24}}  isHeader={true} icon={this.state.img}/>
                    <View style={styles.containerCamera}>
                        <View><CameraPicto style={{width:25,height:25}} isHeader={true}/></View>
                    </View>
                </TouchableOpacity>
            </View>
            <View style={styles.bottomContainer}><View>
                <View style={styles.inputContainer}>
                    <Text style={styles.labelInput}>{this.props.t("Nom")}</Text>
                    <TextInput onChangeText={(text)=>{this.setStateValue(text,"nom")}} style={styles.textInput} value={this.state.nom}
                               editable={editable} selectTextOnFocus={selectTextOnFocus} />
                </View>
                <View style={styles.inputContainer}>
                    <Text style={styles.labelInput}>{this.props.t("Prenom")}</Text>
                    <TextInput onChangeText={(text)=>{this.setStateValue(text,"prenom")}} style={styles.textInput} value={this.state.prenom}
                               editable={editable} selectTextOnFocus={selectTextOnFocus} />
                </View>
                <View style={styles.inputContainer}>
                    <Text style={styles.labelInput}>{this.props.t("Bio")}</Text>
                    <TextInput onChangeText={(text)=>{this.setStateValue(text,"bio")}} multiline={true} style={[styles.textInput,{height:100}]} value={this.state.bio}
                               editable={editable} selectTextOnFocus={selectTextOnFocus} />
                </View>
            </View>
        </View>
        </View>
            );
    }
}

const mapStateToProps = (state) => {
    return {
      isDark: state.changeTheme.isDark, theme: state.changeTheme.theme, auth: state.AuthReducer,
      online: state.sw_reducer.online
    };
}

export default compose(connect(mapStateToProps),withTranslation())(EditProfilScreen);

